export const ALERT_REQUESTED_ORDERS_DAYS = 3;
export const FLOMECOL_IS_USERNAME = 'flomecol_ventas_SI';